const QUARTER_SUFFIXES = ['st', 'nd', 'rd', 'th'] as const;

/**
 * Accepts the trailing asterisk the labels used to carry, so quarterly rows read out of an older
 * master file still match.
 */
const QUARTER_LABEL_PATTERN = /^([1-4])(?:st|nd|rd|th)\s+Quarter\*?$/i;

/**
 * The one place a quarter's row label is spelled.
 *
 * The dashboard merges API rows with rows parsed from the master file by matching `row.label`
 * exactly, and both sides build the label themselves — so the spelling has to come from here or the
 * two silently stop matching and the quarterly grid loses its spreadsheet-sourced years.
 */
export function getQuarterLabel(quarter: number): string {
  const suffix = QUARTER_SUFFIXES[quarter - 1] ?? 'th';

  return `${quarter}${suffix} Quarter`;
}

export function getQuarterNumberFromLabel(label: string): number | null {
  const match = label.trim().match(QUARTER_LABEL_PATTERN);

  return match ? Number(match[1]) : null;
}
